import React, {useEffect, useRef, useState} from "react";
import {fabric} from 'fabric'
import {blobToBase64, urlToObjectUrl} from "../utils";
import useTranslation from "../../virtual_congress/effects/use_translation";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const deleteObject = (eventData, transform) => {
  const target = transform.target;
  const canvas = target.canvas;
  canvas.remove(target);
  canvas.requestRenderAll();
}

const deleteIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB5PSIwIiB4PSIwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSLlnJblsaRfMSIgdmVyc2lvbj0iMS4xIiB3aWR0aD0iMjAwcHgiIGhlaWdodD0iMjAwcHgiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0id2lkdGg6MTAwJTtoZWlnaHQ6MTAwJTthbmltYXRpb24tcGxheS1zdGF0ZTpwYXVzZWQiID48ZyBjbGFzcz0ibGRsLXNjYWxlIiBzdHlsZT0idHJhbnNmb3JtLW9yaWdpbjo1MCUgNTAlIDBweDt0cmFuc2Zvcm06cm90YXRlKDBkZWcpIHNjYWxlKDAuOCk7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkIiA+PHBhdGggZD0iTTIyIDc4bDU2LTU2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMTYiIHN0cm9rZT0iI2UxNWI2NCIgZmlsbD0ibm9uZSIgc3R5bGU9InN0cm9rZTpyZ2IoMjI1LCA5MSwgMTAwKTthbmltYXRpb24tcGxheS1zdGF0ZTpwYXVzZWQiID48L3BhdGg+CjxwYXRoIGQ9Ik03OCA3OEwyMiAyMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjE2IiBzdHJva2U9IiNlMTViNjQiIGZpbGw9Im5vbmUiIHN0eWxlPSJzdHJva2U6cmdiKDIyNSwgOTEsIDEwMCk7YW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkIiA+PC9wYXRoPgo8bWV0YWRhdGEgeG1sbnM6ZD0iaHR0cHM6Ly9sb2FkaW5nLmlvL3N0b2NrLyIgc3R5bGU9ImFuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZCIgPjxkOm5hbWUgc3R5bGU9ImFuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZCIgPmZhaWw8L2Q6bmFtZT4KPGQ6dGFncyBzdHlsZT0iYW5pbWF0aW9uLXBsYXktc3RhdGU6cGF1c2VkIiA+ZXJyb3Isd2FybmluZyxkYW5nZXIsY3Jvc3MsdGltZXMsZGVsZXRlLHJlbW92ZSxkcm9wLGZhaWwsZm9ybTwvZDp0YWdzPgo8ZDpsaWNlbnNlIHN0eWxlPSJhbmltYXRpb24tcGxheS1zdGF0ZTpwYXVzZWQiID5mcmVlPC9kOmxpY2Vuc2U+CjxkOnNsdWcgc3R5bGU9ImFuaW1hdGlvbi1wbGF5LXN0YXRlOnBhdXNlZCIgPmp4anlpdjwvZDpzbHVnPjwvbWV0YWRhdGE+PC9nPjwhLS0gZ2VuZXJhdGVkIGJ5IGh0dHBzOi8vbG9hZGluZy5pby8gLS0+PC9zdmc+"
const img = document.createElement('img');
img.src = deleteIcon;

fabric.Object.prototype.transparentCorners = false;
fabric.Object.prototype.cornerColor = 'blue';
fabric.Object.prototype.cornerSize = 35;
fabric.Object.prototype.cornerStyle = 'red';
fabric.Object.prototype.has = 'red';

const renderIcon = (ctx, left, top, styleOverride, fabricObject) => {
  const size = 90;
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(img, -size / 2, -size / 2, size, size);
  ctx.restore();
}

fabric.Object.prototype.controls.deleteControl = new fabric.Control({
  x: 0.5,
  y: -0.5,
  offsetY: -45,
  offsetX: 45,
  cursorStyle: 'pointer',
  mouseUpHandler: deleteObject,
  render: renderIcon,
  cornerSize: 90
});

const FabricEditor = ({
                        imageBlob,
                        onFinished,
                        photoBoothConfig,
                        onResetClicked,
                        onBackClicked,
                        translationHtmlContent,
                      }) => {
  const t = useTranslation(translationHtmlContent)
  const canvasRef = useRef(null);
  const rotationRef = useRef(null);
  const textInputRef = useRef(null);
  const [canvas, setCanvas] = useState()
  const [dataUrl, setDataUrl] = useState()
  const [hasSelectedObject, setHasSelectedObject] = useState(false)
  const [hasSelectedTextObject, setHasSelectedTextObject] = useState(false)
  const [selectedTextObjectText, setSelectedTextObjectText] = useState("")
  const [canvasContainerHeight, setCanvasContainerHeight] = useState(0)
  const isMobileByMediaQuery = useMediaQuery('(max-width:768px)');
  const sticker = photoBoothConfig.stickers.map(e => {
    return {
      key: e.id,
      src: e.url
    }
  })

  useEffect(() => {
    if (canvasRef.current) {
      const currentCanvas = new fabric.Canvas(canvasRef.current, {backgroundColor: 'transparent'});
      setCanvas(currentCanvas)

      currentCanvas.on('selection:created', (options) => {
        setHasSelectedObject(true)
        setHasSelectedTextObject(options.selected.some(activeObject => activeObject.type == "i-text"))
        setSelectedTextObjectText(options.selected.find(activeObject => activeObject.type == "i-text")?.text)
      });

      currentCanvas.on('selection:updated', (options) => {
        setHasSelectedObject(true)
        setHasSelectedTextObject(options.selected.some(activeObject => activeObject.type == "i-text"))
        setSelectedTextObjectText(options.selected.find(activeObject => activeObject.type == "i-text")?.text)
      });

      currentCanvas.on('selection:cleared', (options) => {
        setHasSelectedObject(false)
        setHasSelectedTextObject(false)
        setSelectedTextObjectText("")
      });

      return () => {
        currentCanvas.dispose()
      }
    }
  }, [canvasRef.current, setCanvas, setHasSelectedObject])

  useEffect(() => {
    const resizeEventListener = () => {
      if (canvasRef.current) {
        const clientHeight = canvasRef.current.clientHeight
        setCanvasContainerHeight(clientHeight)
      }
    }

    window.addEventListener('resize', resizeEventListener)

    return () => {
      window.removeEventListener('resize', resizeEventListener)
    }
  }, [setCanvasContainerHeight, canvasRef.current])

  useEffect(() => {
    if (canvasRef.current) {
      const clientHeight = canvasRef.current.clientHeight
      setCanvasContainerHeight(clientHeight)
    }
  }, [setCanvasContainerHeight, canvasRef.current])

  useEffect(() => {
    blobToBase64(imageBlob).then(du => {
      setDataUrl(du)
    })
  }, [])

  useEffect(() => {
    if (canvas && dataUrl) {
      fabric.Image.fromURL(dataUrl, function (img) {
        img.scaleToWidth(photoBoothConfig.target_image_width);
        img.scaleToHeight(photoBoothConfig.target_image_height);

        canvas.setBackgroundImage(img);
        canvas.requestRenderAll();
      });
    }
  }, [canvas, dataUrl])

  const onSaveButtonClicked = () => {
    const dataUrl = canvas.toDataURL('image/png')

    fetch(dataUrl)
      .then(res => res.blob())
      .then(blob => onFinished(blob))
  }

  const onSelectedSticker = (sticker) => {
    return () => {
      urlToObjectUrl(sticker.src).then(url => {
        fabric.Image.fromURL(url, function (img) {
          canvas.add(img);
        }.bind(this), {
          crossOrigin: 'anonymous'
        });
      })
    }
  }

  const onClickAddText = () => {
    canvas.add(new fabric.IText(photoBoothConfig.sticker_text_default_text || 'Tap and Type', {
      fontFamily: photoBoothConfig.sticker_text_font_family,
      fontSize: photoBoothConfig.sticker_text_font_size,
      fill: photoBoothConfig.sticker_text_fill,
      left: 200,
      top: 200,
    }));
  }

  const onRotationChanged = (e) => {
    if (hasSelectedObject) {
      canvas.getActiveObjects().forEach(activeObject => {
        activeObject.rotate(e.target.value)
      })
      canvas.renderAll();
    }
  }

  const decreaseSelectionSize = (e) => {
    if (hasSelectedObject) {
      canvas.getActiveObjects().forEach(activeObject => {
        activeObject.scaleToWidth(Math.max(0.001, activeObject.getScaledWidth() - (activeObject.getScaledWidth() * 0.1)))
        activeObject.scaleToHeight(Math.max(0.001, activeObject.getScaledHeight() - (activeObject.getScaledHeight() * 0.1)))
      })
      canvas.renderAll();
    }
  }

  const increaseSelectionSize = (e) => {
    if (hasSelectedObject) {
      canvas.getActiveObjects().forEach(activeObject => {
        activeObject.scaleToWidth(Math.max(0.001, activeObject.getScaledWidth() + (activeObject.getScaledWidth() * 0.1)))
        activeObject.scaleToHeight(Math.max(0.001, activeObject.getScaledHeight() + (activeObject.getScaledHeight() * 0.1)))
      })
      canvas.renderAll();
    }
  }

  const onTextInputChange = (e) => {
    setSelectedTextObjectText(e.target.value)

    if (hasSelectedObject) {
      const textObject = canvas.getActiveObjects().find(activeObject => activeObject.type == "i-text")
      textObject.text = e.target.value
      canvas.renderAll();
    }
  }

  return <div className={"fabric-container"}>
    <canvas
      ref={canvasRef}
      className={"fabric-canvas"}
      width={photoBoothConfig.target_image_width}
      height={photoBoothConfig.target_image_height}
    />

    <div style={{marginTop: `${canvasContainerHeight}px`}}/>

    {isMobileByMediaQuery && hasSelectedObject && <div className={"mobile-container"}>

      {hasSelectedTextObject && <>
        <label htmlFor="text-input">
          {t("photo_booth.fabric.text_input", {}, "Text")}
        </label>
        <input
          ref={textInputRef}
          id={"text-input"}
          className={"text-input"}
          value={selectedTextObjectText}
          type="text"
          onChange={onTextInputChange}
        />
      </>}

      <label htmlFor="rotation-slider">
        {t("photo_booth.fabric.rotation_label", {}, "Rotate")}
      </label>
      <input
        ref={rotationRef}
        id={"rotation-slider"}
        className={"rotation-slider"}
        type="range"
        min="-180"
        max="180"
        defaultValue="0"
        onChange={onRotationChanged}
      />

      <div className="size-button-container">
        <button
          onClick={decreaseSelectionSize}
          className={"photo-booth-button decrease-size-button"}
          type={"button"}>
          {t("photo_booth.fabric.decrease_button_html", {}, "<i class=\"far fa-minus-circle\"></i>")}
        </button>
        {t("photo_booth.fabric.resize_description_html", {}, "Resize")}
        <button
          onClick={increaseSelectionSize}
          className={"photo-booth-button increase-size-button"}
          type={"button"}>
          {t("photo_booth.fabric.increase_button_html", {}, "<i class=\"far fa-plus-circle\"></i>")}
        </button>
      </div>
    </div>}

    <div className={"emoji-container"} >
      {sticker.map(sticker => {
        return <button
          key={sticker.key}
          className={"emoji-button asset-button"}
          type={"button"}>
          <img
            className={"emoji-image"}
            onClick={onSelectedSticker(sticker)}
            src={sticker.src}/>
        </button>
      })}

      <button
        type={"button"}
        className={"add-text-button photo-booth-button"}
        onClick={onClickAddText}
      >
        {t("photo_booth.fabric.add_text_button_html", {}, "Add text")}
      </button>
    </div>
    <div className="button-container">
      <button
        className={"photo-booth-button back-button"}
        onClick={onBackClicked}
        type={"button"}>
        {t("photo_booth.fabric.back_button_html", {}, "Back")}
      </button>

      <button
        className={"photo-booth-button back-button"}
        onClick={onResetClicked}
        type={"button"}>
        {t("photo_booth.fabric.reset_button_html", {}, "Reset")}
      </button>

      <button
        className={"finished-button photo-booth-button"}
        type={"button"}
        onClick={onSaveButtonClicked}
      >
        {t("photo_booth.fabric.continue_button_html", {}, "Save")}
      </button>
    </div>
  </div>
}

export default FabricEditor